import React from "react";
import { SensorTypeDropdown } from "components/gateways/SensorTypeDropdown";
import { ActuatorTypeDropdown } from "./ActuatorTypeDropdown";

type FiltersParams = {
    tabKey: string;
    sensorTypes: any[];
    actuatorTypes: any[];
    selectedSensorTypes: string[];
    setSelectedSensorTypes: (types: string[]) => void;
    selectedActuatorTypes: string[];
    setSelectedActuatorTypes: (types: string[]) => void;
};

export const renderSensorsControllersFilters = ({
    tabKey,
    sensorTypes,
    actuatorTypes,
    selectedSensorTypes,
    setSelectedSensorTypes,
    selectedActuatorTypes,
    setSelectedActuatorTypes,
}: FiltersParams): React.ReactNode => {
    if (tabKey === "sensors") {
        return (
            <SensorTypeDropdown
                sensorTypes={sensorTypes}
                onChange={setSelectedSensorTypes}
                selected={selectedSensorTypes}
            />
        );
    }

    if (tabKey === "controllers") {
        return (
            <ActuatorTypeDropdown
                actuatorTypes={actuatorTypes}
                onChange={setSelectedActuatorTypes}
                selected={selectedActuatorTypes}
            />
        );
    }

    return null;
};

